import React, { Component } from "react";
import Modal from "react-modal";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  selectAlertMessage,
  hideModal
} from "../../../state/ducks/alert/index";


Modal.setAppElement("#app");

class index extends Component {

  state = {
    alertType:
      this.props.alert?.type === "ALERT_SUCCESS" ? "success" : "danger",
  };
  hideModal = () => {
    if (this.props.alert?.redirect != null) {
      this.props.history.push(this.props.alert.redirect);
    }
    this.props.hideModal();
  };

  render() {
    const { alert, type } = this.props;
    if (!alert?.isOpen) {
      return null;
    }
    var colorGenel = (type == "success" ? '#3AAA35' : 'rgb(241, 90, 42)')
    var iconName = (type == "success" ? 't-icon-check_circle_outline' : 't-icon-exclamation')
    return (
      <Modal
        isOpen={alert?.isOpen}
        onRequestClose={this.closeModal}
        style={{
          overlay: {
            position: 'fixed',

            inset: "30% 5% 5% 5%",
            left: 0,
            right: 0,

            bottom: 0,
            backgroundColor: 'unset !important'
          },
          content: {
            position: 'fixed',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            top: 0,
            left: 0,
            border: '0px',


            backgroundColor: 'transparent' /* Black w/ opacity */

          }
        }}
      >

        <div className="t-modalAreaAlert" id="id-modal"

        >
          <div className="t-modalContentAlert" id="id-modalTipi" style={(window.innerWidth<=900)?{width:"89%"}: {width:"50%"}}>
            <div
              className="t-modal"
              id="id-modalGenel"
              style={{ backgroundColor: colorGenel }}
            >
              <div className="container-fluid">
                {/* Header */}
                <div className="row t-modalHeader">
                  <div
                    className="col"
                    id="id-modalHeader"
                    style={{ color: "rgb(255, 221, 221)" }}
                  />
                  <div className="col-auto t-cursorPointer" data-dismiss="modal" onClick={this.hideModal} >
                    <i
                      className="t-icon-cross"
                      id="id-modalHeaderIcon"
                      style={{ color:"white" }}
                    />
                  </div>
                </div>
                {/* Body */}
                <div className="row t-modalBody">
                  <div
                    className="col-12"
                    id="id-modalBody"
                    style={{ color: "rgb(255, 204, 204)" }}
                  >
                    <div className="w-100 text-center" style={{ fontSize: "14pt" }}>
                      <i className={iconName} style={{ fontSize: "60px", color:"white"}} />
                      <br />
                      <br />
                      <b style={{ color: "#FFF" }}>
                        {(alert?.message !== "" && alert?.message !== null && !alert?.message?.toString().includes("object"))
                          ? alert.message
                          : "Beklenmeyen bir hata oluştu."}
                      </b>
                    </div>
                  </div>
                </div>
                {/* footer*/}
                <div className="row t-modalFooter">
                  <div
                    className="col-12"
                    id="id-modalFooter"
                    style={{ color: "rgb(255, 187, 187)" }}
                  />
                </div>
              </div>
            </div>

          </div>


        </div>

      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    alert: selectAlertMessage(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  hideModal: () => dispatch(hideModal())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(index));
